import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router-dom'

import Security from '../../commons/security/Security.js'
import DataTable from 'datatables.net-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-autofill-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.flash.js'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
import 'datatables.net-colreorder-bs4/css/colReorder.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'
import 'datatables.net-responsive-bs4'
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css'
import 'datatables.net-rowreorder-bs4/css/rowReorder.bootstrap4.css'
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css'
import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import '../../assets/css/vec-datatables.css'
//import datatablesConfig from '../../commons/datatables/DatatablesConfig.js'
import Config from '../../commons/config/Config.js'
import swal from 'sweetalert'
import jzip from 'xlsx/dist/jszip'
import 'xlsx/dist/xlsx.full.min.js'
import LogoCompany from '../../assets/images/logo-company.png'
import LogoVecFleet from '../../assets/images/logo-vecfleet.png'
import $ from 'jquery'
import dtConfig from './PanolGrid.js'

import { getCategorias, createCategorias, updateCategorias, deleteCategorias } from './MetodosPanol.js' 
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

$.DataTable = DataTable;
window.JSZip = jzip;
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class CategoriasAbm extends Component { 
	constructor(props) {
		super(props);
		this.state = {
			redirectTo: null,
			loading: true,
			grid: null,
			create: null,
			update: null,
			delete: null
		}
	}
	async componentDidMount() {
		
    	let component = this;
    	let filters = null;
		let getGrid = await getCategorias().then(res=>{
    		let dataR = res.data;
	        this.setState({
	            grid: dataR
	        })
	      
	    });
	    const config = {
    	headers: { 
    		'Content-Type': 'application/json',
			'Authorization-Token': localStorage.getItem("token")
    	 }
		};	    
       	let table = $(this.refs.main).DataTable(
       		Object.assign({
				//dom: '<t><"row mt-2"<"col-4" l><"col-4 text-center" i><"col-4" p>>',
				stateSave: true,
				stateSaveCallback: function(settings,data) {
					localStorage.setItem('DataTables_CategoriasAbm', JSON.stringify(data) );
				},
				stateLoadCallback: function(settings) {
					return JSON.parse( localStorage.getItem('DataTables_CategoriasAbm') );
				},
           	ajax: {
					type: 'GET',
					url: Config.get('apiUrlBase') + '/panol/categorias/grid',
					
					headers: {
						'Content-Type': 'application/json',
						'Authorization-Token': localStorage.getItem("token")
					},
					dataSrc: function(res){
						return component.state.grid
					},
					error: function (xhr, error, thrown) {
					},
					cache: false
				},
			initComplete: function (settings) {
				let stateColumns = JSON.parse(localStorage.getItem('DataTables_CategoriasAbm')).columns;
				var sets = settings;
				var index = 0;
				this.api().columns().every( function () {
					var column = this;
					if(sets.aoColumns[index].filterType){
						if(sets.aoColumns[index].filterType === 'select') {
							var select = $('<select class="btn-dt-filter" required><option value="" selected>'+component.props.intl.formatMessage({ id: 'categoriasAbm.initGrid.columns_searh_filter.buscar', defaultMessage: 'Buscar...' })+'</option></select>')
								.appendTo( $(column.footer()).empty() )
								.on( 'change', function () {
									var val = $.fn.dataTable.util.escapeRegex($(this).val());
									column
										.search( val ? val : '', true, false )
										.draw();
								});								
							if(filters && sets.aoColumns[index].name && filters[sets.aoColumns[index].name]) {
								filters[sets.aoColumns[index].name].map(e => {
									select.append('<option value="'+e.value+'">'+e.label+'</option>');
									return true;
								});
							} else {
								column.data().unique().sort().each( function ( d, j ) {
									select.append( '<option value="'+d+'">'+d+'</option>' );
								});
							}
							if(stateColumns[index].search.search) select.val(stateColumns[index].search.search);
						}
						if(sets.aoColumns[index].filterType === 'input') {
							var input = $('<input type="text" class="btn-dt-filter" placeholder="'+component.props.intl.formatMessage({ id: 'categoriasAbm.initGrid.columns_searh_filter.placeholder_buscar', defaultMessage: 'Buscar...' })+'" />');
							if(stateColumns[index].search.search) input.val(stateColumns[index].search.search);
							input.appendTo($(column.footer()).empty());
							input.on( 'keyup change', function () {
								if ( column.search() !== this.value ) {
									column
									.search( this.value )
									.draw()
									.ajax.reload(null, false);
								}
							});
						}
					}
					index++;
					return '';
				});
				$('tfoot tr').appendTo('thead');
			},
           	columns: [
           		{ 
	            title: component.props.intl.formatMessage({ id: 'categoriasAbm.column_id.label_id', defaultMessage: 'id' }),
	            className: "text-center",
	            visible: false,
	            data: "id"
	            },
           		{ 
	            title: component.props.intl.formatMessage({ id: 'categoriasAbm.column_category_name.label_nombre_categoria', defaultMessage: 'Nombre Categoria' }),
	            className: "panolRow",
	            data: "nombre",
		        filterType: 'input'
	            },
	            {
				orderable: false,
				data: null,
				className: "text-center",
				width: '120px',
	            render: function () {
					let html =
						(Security.hasPermission('PANOL_CATEGORIAS_MODIFICAR') ? `
						<button class="action edit btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'categoriasAbm.column_actions.button_title_ver', defaultMessage: 'Editar' })+`" >
							<i class="fa fa-pencil fa-xs"></i>
						</button>`: '') +
                        (Security.hasPermission('PANOL_CATEGORIAS_ELIMINAR') ? `
						<button class="action delete btn btn-sm btn-icon btn-dt-grid text-danger" title="`+component.props.intl.formatMessage({ id: 'categoriasAbm.column_actions.button_title_eliminar', defaultMessage: 'Eliminar' })+`">
							<i class="fa fa-trash fa-xs"></i>
						</button>`: '');
                    return html;
				}
        	}],
        	sDom: 'lrtip',
			orderCellsTop: true,
        	fixedHeader: true,
        	drawCallback: function () {
						$(this).find('.action').on('click', function () {
							
							if($(this).hasClass('edit')) {
								let data = table.row( $(this).parents('tr') ).data();
								let dataId = data.id;
								console.log(data);
								$("#editCategoriasModal #editIdCategoria").val(data.id);
								$("#editCategoriasModal #editNombreCategoria").val(data.nombre);
								$('#editCategoriasModal').on('shown.bs.modal', function() {
								    $('#editNombreCategoria').trigger('focus');
								    $("#editNombreCategoria").keyup(function(e)
									{
									    if (e.which == 13)
									    {
									        $(this).submit();
									    }
									});
								  });
								$("#editCategoriasModal").modal({show: true});
							}
							if($(this).hasClass('delete')) {
								swal({
								title: component.props.intl.formatMessage({ id: 'categoriasAbm.modal_delete.confirm_eliminacion', defaultMessage: '¿Confirma la eliminación?' }),
								text: null,
								icon: "warning",
								buttons: {
									confirm: {
										text: component.props.intl.formatMessage({ id: 'categoriasAbm.modal_delete.confirm_eliminacion.si', defaultMessage: 'Si' }),
										value: true,
										visible: true,
										className: "btn btn-primary",
										closeModal: false
									},
									cancel: {
										text: component.props.intl.formatMessage({ id: 'categoriasAbm.modal_delete.confirm_eliminacion.no', defaultMessage: 'No' }),
										value: null,
										visible: true,
										className: "btn btn-danger",
										closeModal: true,
									}
								}
							}).then((isConfirm) => {
								if (isConfirm) {
									let data = table.row( $(this).parents('tr') ).data();
									let dataId = data.id;
									console.log("se eliminara el item: "+ data.descripcion);
									deleteCategorias(dataId).then(res => {
										let dataR = res.mensaje;
										swal(component.props.intl.formatMessage({ id: 'categoriasAbm.modal_delete.information_eliminado', defaultMessage: 'Eliminado!' }), "", "success");
										let getGrid2 = getCategorias().then(res2=>{
							    		let dataR2 = res2.data;
									        component.setState({
									            grid: dataR2
									        })
										table.ajax.reload();
									    console.log("actualiza grid:");
									    console.log(component.state.grid);
									    })
									})
									.catch(function(error) {
										swal(component.props.intl.formatMessage({ id: 'categoriasAbm.modal_delete.information_error', defaultMessage: 'Error' }), "", "error");
									});
								}
							}); //fin accion
							
							}
						});
						
					},

		}, dtConfig)
		)
		$(document).find("#example thead th").css("height","43px");
		$(document).find("#example thead th").css("padding-left","20px");
		$(document).find("#example tbody td").css("padding-left","20px");
		$('[data-toggle="tooltip"]').tooltip();

		this.setState({ loading: false });

		new $.fn.dataTable.Buttons( table, {
			buttons: [
				{
          extend: 'print',
          text: '<i class="ft-printer"></i>',
					title: '',
					customize: function(win)
					{
						var css = '@page { size: landscape; }',
							head = win.document.head || win.document.getElementsByTagName('head')[0],
							style = win.document.createElement('style');

						style.type = 'text/css';
						style.media = 'print';

						if (style.styleSheet) {
							style.styleSheet.cssText = css;
						}	else {
							style.appendChild(win.document.createTextNode(css));
						}

						head.appendChild(style);

						$(win.document.body)
							.css( 'font-size', '10pt' )
							.prepend(`<div class="container">
													<div class="row mb-2">
														<div class="col-6">
															<img style="height: 35px" src="`+LogoCompany+`" />
														</div>
														<div class="col-6	text-right">
															<img style="height: 40px" src="`+LogoVecFleet+`" />
														</div>
													</div>
													<div class="row mb-2">
														<div class="col-12" style="border-bottom: 1px solid #000;">
															<h2>`+component.props.intl.formatMessage({ id: 'categoriasAbm.print_content.header_listado_de_regiones', defaultMessage: 'Listado de Regiones' })+`</h2>
														</div>
													</div>
												</div>`);

						$(win.document.body).find( 'table' )
							.addClass( 'compact' )
							.css( 'font-size', 'inherit' );
			 		},
          exportOptions: {
              columns: [ 3,4,5,6 ]
          },
					titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_print.select_title_imprimir', defaultMessage: 'Imprimir' })
        },
        {
          extend: 'colvis',
					text: '<i class="la la-columns"></i>',
					titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_select_columns.select_title_seleccionar_columnas', defaultMessage: 'Seleccionar columnas' })
        },
        {
          extend: 'collection',
					text: '<i class="ft-upload"></i>',
					titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_export.select_title_exportar', defaultMessage: 'Exportar' }),
          buttons: [
          {
            extend: 'copyHtml5',
            exportOptions: {
              columns: ':visible'
            },
						text: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_export.select_text_copiar', defaultMessage: 'Copiar' }),
						titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_export.select_copiar', defaultMessage: 'Copiar' })
          },
          {
            extend: 'excelHtml5',
            exportOptions: {
              columns: ':visible'
						},
						titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_export.select_exportar_excel', defaultMessage: 'Exportar a Excel' })
          },
          {
            extend: 'csvHtml5',
            exportOptions: {
              columns: ':visible'
						},
						titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_export.select_exportar_formato_csv', defaultMessage: 'Exportar en formato .csv' })
          },
          {
            extend: 'pdfHtml5',
            exportOptions: {
              columns: ':visible'
						},
						titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_export.select_exportar_PDF', defaultMessage: 'Exportar a PDF' })
					}
					]
				},
				{
					text: '<i class="ft-download"></i>',
					titleAttr: component.props.intl.formatMessage({ id: 'categoriasAbm.tools_import.select_importar', defaultMessage: 'Importar' })
        },
			]
		});

		table.buttons( 0, null ).container().appendTo('#buttons');

		/*
		}).finally(() => {
			component.setState({
				loading: false
			});
		});
		*/
		$('.buttons-collection').on("click",function(e){ e.stopPropagation(); 
			if($('.dt-button-collection>.dropdown-menu').css('display')=='none')
				$('.dt-button-collection>.dropdown-menu').css('display','block');
		});
    }  
	componentWillUnmount(){
		
       $('.data-table-wrapper')
       .find('table')
       .DataTable()
       .destroy(true);
       
    }
    shouldComponentUpdate() {
        return false;
    }
    onChange = (e) => {
    this.props.history.push(`/panol/config${e.target.value}`);
  }
	onModalEditSubmit = (e) => {
	  		e.preventDefault();  		
	  		let component = this;
	  		let table = $(this.refs.main).DataTable();
	  		updateCategorias(e).then(res =>{

				$(this).find('form').trigger('reset');
				$("#editCategoriasModal").modal("hide");
				swal(component.props.intl.formatMessage({ id: 'categoriasAbm.modal_edit.information_modificado', defaultMessage: 'Modificado!' }), "", "success");
				let getGrid2 = getCategorias().then(res2=>{
	    		let dataR2 = res2.data;
			    component.setState({
			            grid: dataR2
			    })
				table.ajax.reload();
			    console.log("actualiza grid:");
			    console.log(component.state.grid);
			    })
			})
	  	}
	  	onModalNewSubmit = (e) => {
	  		e.preventDefault();
	  		let component = this;
	  		let table = $(this.refs.main).DataTable();
	  		createCategorias(e).then(res =>{

				    $("#newCategoriasModal").find('form').trigger('reset');
				    $("#newCategoriasModal").modal("hide");

				swal(component.props.intl.formatMessage({ id: 'categoriasAbm.modal_add.information_agregado', defaultMessage: 'Agregado!' }), "", "success");
										
				let getGrid2 = getCategorias().then(res2=>{
	    		let dataR2 = res2.data;
			        component.setState({
			            grid: dataR2
			        })
				table.ajax.reload();
			    console.log("actualiza grid:");
			    console.log(component.state.grid);
			    })
			    
			})
			
	  	}

    render() {
        return (
        	<React.Fragment>
        	{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
    		<div className="row mt-2">
				<div className="col-12">
					<div className="card">
						<div className="card-header">
							<h1><FormattedMessage id="categoriasAbm.render.select_module.header_seleccione_el_modulo_a_configurar" defaultMessage="Seleccione el módulo a configurar"/></h1>
						</div>
						<div className="card-content collpase show">
							<div className="card-body card-dashboard">
								
				               	<select className="form-control form-control-lg" defaultValue="/categorias" onChange={this.onChange}>
								  <option value="">Medidas</option>
								  <option value="/marcas">Marcas</option>
								  <option value="/categorias">Categorias</option>
								  <option value="/subcategorias">Sub-Categorias</option>
								  <option value="/items">Items</option>
								</select>
				            </div>
			            </div>
					</div>
				{/*modal new Categorias*/}
					<div className="card">
						<div className="card-content collpase show">
							<div className="card-body card-dashboard">
								<div className="container-fluid">
									<div className="row dt-icons">
										<div className="col-6">
                                            {Security.renderIfHasPermission('PANOL_CATEGORIAS_CREAR', (
											<div 
												className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"  
												data-toggle="tooltip" 
												data-placement="right" 
												title={this.props.intl.formatMessage({ id: 'categoriasAbm.render.button_add_category.placeholder_nueva_categoria', defaultMessage: 'Nueva Categoria' })}
												data-toggle="modal" 
												data-target="#newCategoriasModal"
												>
												<i className="ft-plus"></i>
											</div>))}
											
										</div>
										<div className="col-6" id="buttons"></div>
									</div>
								</div> 
				               	<div>
				               		<table id="example" ref="main" className="nowrap table-hover dataTableMovil" width="100%">
										<tfoot>
											<tr style={{backgroundColor: '#fff'}}>
												<th className=""></th>	
												<th className="dt-search-header"><FormattedMessage id="categoriasAbm.render.table_column_nombre_categoria" defaultMessage="Nombre Categoria"/></th>
												<th className=""></th>
											</tr>
										</tfoot>
									</table>
					            </div>

				            </div>
			            </div>
					</div>
				</div>
			{/*---Modal nueva Categoria---*/}
				<div className="modal fade" id="newCategoriasModal" tabIndex="-1" role="dialog" aria-labelledby="newCategoriasModalLabel" aria-hidden="true">
				  <div className="modal-dialog" role="document">
				    <div className="modal-content">
				      <div className="modal-header">
				        <h5 className="modal-title" id="newCategoriasModalLabel"><FormattedMessage id="categoriasAbm.render.modal_add_category.header_nueva_categoria" defaultMessage="Nueva Categoria"/></h5>
				        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
				          <span aria-hidden="true">&times;</span>
				        </button>
				      </div>
				      <form onSubmit={this.onModalNewSubmit}>
					      <div className="modal-body">
					        <div className="row">
						        <div className="col-md-12">
						          <div className="form-group">
							           	<label htmlFor="nombreCategoria" className="col-form-label"><FormattedMessage id="categoriasAbm.render.modal_add_category.label_nombre_categoria" defaultMessage="Nombre de la Categoria:"/></label>
							            <input 
							            	type="text" 
							            	className="form-control" 
							            	name="nombre" 
							            	id="newNombreCategoria"
							            	placeholder={this.props.intl.formatMessage({ id: 'categoriasAbm.render.modal_add_category.placeholder_nombre_categoria', defaultMessage: 'Ej: Aceites' })}
							            />
						          </div>
						          </div>
						        </div>
				          	</div>					       
					      <div className="modal-footer">
					        <button type="button" className="btn btn-secondary" data-dismiss="modal"><FormattedMessage id="categoriasAbm.modal_add_category.finish_button.cancelar" defaultMessage="Cancelar"/></button>
					        <button type="submit" className="btn btn-primary"><FormattedMessage id="categoriasAbm.modal_add_category.finish_button.guardar_datos" defaultMessage="Guardar datos"/></button>
					      </div>
				      </form>
				    </div>
				  </div>
				</div>

				{/*---Modal edit Marca---*/}
				<div className="modal fade" id="editCategoriasModal" tabIndex="-1" role="dialog" aria-labelledby="editCategoriasModalLabel" aria-hidden="true">
				  <div className="modal-dialog" role="document">
				    <div className="modal-content">
				      <div className="modal-header">
				        <h5 className="modal-title" id="editCategoriasModalLabel"><FormattedMessage id="categoriasAbm.render.modal_edit_category.header_editar_categoria" defaultMessage="Editar Categoria"/></h5>
				        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
				          <span aria-hidden="true">&times;</span>
				        </button>
				      </div>
				    	<form onSubmit={this.onModalEditSubmit}>
					      <div className="modal-body">
					        <div className="row">
						        <div className="col-md-12">
						          <div className="form-group">
						          		<input 
							            	type="hidden" 
							            	className="form-control" 
							            	name="id" 
							            	id="editIdCategoria"
							            />
						           		<label htmlFor="nombreCategoria" className="col-form-label"><FormattedMessage id="categoriasAbm.render.modal_edit_category.label_nombre_categoria" defaultMessage="Nombre de la Categoria:"/></label>
							            <input 
							            	type="text" 
							            	className="form-control" 
							            	name="nombre" 
							            	id="editNombreCategoria"
							            />
						          </div>
						        </div>
				          		</div>
						      </div>
						      <div className="modal-footer">
						        <button type="button" className="btn btn-secondary" data-dismiss="modal"><FormattedMessage id="categoriasAbm.modal_edit_category.finish_button.cancelar" defaultMessage="Cancelar"/></button>
						        <button type="submit" className="btn btn-primary"><FormattedMessage id="categoriasAbm.modal_edit_category.finish_button.guardar_datos" defaultMessage="Guardar datos"/></button>
						      </div>
				        </form>
				    </div>
				  </div>
				</div>

				
			</div>
		</React.Fragment>
            );
    }
}

export default injectIntl(CategoriasAbm);